import { render, staticRenderFns } from "./el-backtop.vue?vue&type=template&id=68c45ebe"
import script from "./el-backtop.vue?vue&type=script&lang=js"
export * from "./el-backtop.vue?vue&type=script&lang=js"
import style0 from "./el-backtop.vue?vue&type=style&index=0&id=68c45ebe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports